import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { FluentProvider, IOption } from "@/dependencies";
import {
  Combobox,
  Field,
  FieldProps,
  Listbox,
  makeStyles,
  Option,
  OptionOnSelectData,
  SelectionEvents,
  Slot,
} from "@fluentui/react-components";
import { ChangeEvent } from "react";

interface ComboboxFieldProps {
  rcName?: string;
  theme?: string;
  name?: string;
  rcRole?: string[];
  requireRoles?: string[];
  requireOwner?: boolean;
  isOwner?: boolean;
  selectedOptions?: string[];
  multiselect?: boolean;
  disabled?: boolean;
  options?: IOption[];
  listbox?: Slot<typeof Listbox>;
  onSelectOption?: (event: SelectionEvents, data: OptionOnSelectData) => void;
  placeholder?: string;
  acceptText?: boolean;
  value?: string;
  onChangeText?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const useStyles = makeStyles({
  disabled: {
    backgroundColor: "var(--colorSubtleBackgroundHover)",
    "& input": {
      color: "var(--colorNeutralForeground1)",
    },
  },
});


const ComboboxField = (props: ComboboxFieldProps & FieldProps) => {
  const styles = useStyles();
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles,
  ) && (props.requireOwner ? props.isOwner : true);

  const onOptionSelect = (event: SelectionEvents, data: OptionOnSelectData) => {
    if (props.onSelectOption) {
      props.onSelectOption(event, data);
    }
  };

  const isDisabled = props.disabled || !isCanBeVisible;

  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Field
        label={props.label}
        validationMessage={props.validationMessage}
        validationMessageIcon={props.validationMessageIcon}
        validationState={props.validationState}
        required={props.required}
      >
        <Combobox
          selectedOptions={props.selectedOptions}
          onOptionSelect={onOptionSelect}
          multiselect={props.multiselect}
          disabled={isDisabled}
          listbox={
            props.listbox ? (
              props.listbox
            ) : (
              <div
                className="listbox"
                style={{ maxHeight: 300, overflowY: "auto" }}
              >
                {(props.options || []).map((item, index) => (
                  <Option key={`${props.rcName}-${index}`} value={item.value}>
                    {item.text}
                  </Option>
                ))}
              </div>
            )
          }
          placeholder={props.placeholder}
          onChange={props.onChangeText}
          value={props.value}
          className={`${isDisabled ? styles.disabled : ""}`}
        />
      </Field>
    </FluentProvider>
  ) : (
    <Field
      label={props.label}
      validationMessage={props.validationMessage}
      validationMessageIcon={props.validationMessageIcon}
      validationState={props.validationState}
      required={props.required}
    >
      <Combobox
        selectedOptions={props.selectedOptions}
        onOptionSelect={onOptionSelect}
        multiselect={props.multiselect}
        disabled={props.disabled || !isCanBeVisible}
        listbox={props.listbox}
        placeholder={props.placeholder}
        onChange={props.acceptText ? props.onChangeText : undefined}
      >
        {(props.options || []).map((item, index) => (
          <Option key={`${props.rcName}-${index}`} value={item.value}>
            {item.text}
          </Option>
        ))}
      </Combobox>
    </Field>
  );
};

export default ComboboxField;
